module.exports = __webpack_public_path__ + "static/media/MassivePaymentTemplate.9ce1c185.xlsx";